import { render } from "./AddressOfNei.vue?vue&type=template&id=08ced24d&scoped=true"
import script from "./AddressOfNei.vue?vue&type=script&lang=ts"
export * from "./AddressOfNei.vue?vue&type=script&lang=ts"

import "./AddressOfNei.vue?vue&type=style&index=0&id=08ced24d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-08ced24d"

export default script